module.exports = __webpack_public_path__ + "static/img/055.18a9eee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/055.png
// module id = pspC
// module chunks = 0